export enum CssColours {
  WHITE = '#FFFFFF',
  BLACK = '#000000',
  TRANSPARENT = 'transparent',
  SERATO_RGB_YELLOW = '#FBD300',
  SERATO_RGB_BLUE = '#003FFF',
  SERATO_RGB_RED = '#E01912',
  SERATO_RGB_GREEN = '#0DAF15',
  SERATO_RGB_TURQUOISE = '#00D8D8',
  SERATO_RGB_PINK = '#F800AD',
  SERATO_RGB_PURPLE = '#8200FF',
  SERATO_RGB_ORANGE = '#FF5C00',
  INTERACTIVE_BLUE = '#00B4F0',
  PALE_BLUE = '#AFEEE4',
  WAVEFORM_PURPLE = '#A070E4',
  WAVEFORM_HOVER_PURPLE='#A652FF'
}

export const fontColours: string[] = [
  CssColours.WHITE,
  CssColours.BLACK,
  CssColours.SERATO_RGB_YELLOW,
  CssColours.SERATO_RGB_BLUE,
  CssColours.SERATO_RGB_RED,
  CssColours.SERATO_RGB_GREEN,
  CssColours.SERATO_RGB_TURQUOISE,
  CssColours.SERATO_RGB_PINK,
  CssColours.SERATO_RGB_PURPLE,
  CssColours.SERATO_RGB_ORANGE
]

export enum DuotoneColours {
  RUBY_LITE = '#DB0E2C',
  RUBY_DARK = '#0F0D22',
  GRANITE_LITE = '#F13B32',
  GRANITE_DARK = '#00435A',
  PEACH_LITE = '#AFECEE',
  PEACH_DARK = '#F05C56',
  DAMSON_LITE = '#73FF20',
  DAMSON_DARK = '#2B2454',
  GUAVA_LITE = '#DAF436',
  GUAVA_DARK = '#FE00AE',
  GRAPE_LITE = '#00D8D8',
  GRAPE_DARK = '#8200FF',
  LYCHEE_LITE = '#FF6754',
  LYCHEE_DARK = '#5872BE',
  LIME_LITE = '#F4DB33',
  LIME_DARK = '#2B9352',
  GRAPHITE_LITE = '#DFE3E5',
  GRAPHITE_DARK = '#49647F'
}